module.exports = __webpack_public_path__ + "img/iu-sig-formal.755df59a.svg";